import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import api from "../api/axios";
import DataTable from "react-data-table-component";
import { toast } from "react-toastify";

const Product = () => {
  const BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const [products, setProduct] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState([]);
  const [filterText, setFilterText] = useState("");
  const history = useHistory();

  const fetchProduct = async () => {
    try {
      const response = await api.post("/product/get");
      if (response.data.success) {
        setProduct(response.data.product);
      } else {
        setError("Product not found");
      }
    } catch (err) {
      setError("Error fetching product details");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProduct();
  }, []);

  const filteredItems = products.filter((item) =>
    item.name.toLowerCase().includes(filterText.toLowerCase()),
  );

  const deleteProduct = async (e, id) => {
    e.preventDefault();
    try {
      const response = await api.post(`/product/delete/${id}`);
      if (response) {
        fetchProduct();
        toast.success("Product Delete Success");
      }
    } catch (error) {
      console.log(error);
    }
  };
  const addProduct = async (e, id) => {
    try {
      e.preventDefault();
      localStorage.setItem("product-list", null);
      history.push("add-product");
    } catch (error) {
      console.log(error);
    }
  };

  const editProduct = async (e, row) => {
    try {
      e.preventDefault();
      localStorage.setItem("product-list", JSON.stringify(row));
      history.push("add-product");
    } catch (error) {
      console.log(error);
    }
  };

  const toggleHomeDisplay = async (id, currentStatus) => {
    try {
      const newStatus = currentStatus === 1 ? 0 : 1;

      await api.post(`/products/${id}/toggle-home`, {
        display_home: newStatus,
      });

      toast.success("Home display status updated!");

      setProduct((prevProducts) =>
        prevProducts.map((item) =>
          item.id === id ? { ...item, display_home: newStatus } : item,
        ),
      );
    } catch (error) {
      console.error("Error updating home display:", error);
      toast.error("Failed to update home display status.");
    }
  };

  const toggleFeaturedDisplay = async (id, currentStatus) => {
    try {
      const newStatus = currentStatus === 1 ? 0 : 1;

      await api.post(`/products/${id}/toggle-feature`, {
        display_feature: newStatus,
      });

      toast.success("Feature display status updated!");

      setProduct((prevProducts) =>
        prevProducts.map((item) =>
          item.id === id ? { ...item, display_feature: newStatus } : item,
        ),
      );
    } catch (error) {
      console.error("Error updating feature display:", error);
      toast.error("Failed to update feature display status.");
    }
  };

  const toggleAboutDisplay = async (id, currentStatus) => {
    try {
      const newStatus = currentStatus === 1 ? 0 : 1;

      await api.post(`/products/${id}/toggle-about`, {
        display_about: newStatus,
      });

      toast.success("About display status updated!");

      setProduct((prevProducts) =>
        prevProducts.map((item) =>
          item.id === id ? { ...item, display_about: newStatus } : item,
        ),
      );
    } catch (error) {
      console.error("Error updating about display:", error);
      toast.error("Failed to update about display status.");
    }
  };

  const columns = [
    {
      name: "Id",
      selector: (row) => row.id,
      sortable: true,
      width: "100px",
    },
    {
      name: "Image",
      cell: (row) => (
        <img
          src={`${BASE_URL}/${row.image}`}
          alt={row.name}
          width="80"
          height="50"
          style={{ borderRadius: "8px", border: "1px solid #c5c5c5" }}
        />
      ),
      width: "200px",
    },
    {
      name: "Category Name",
      selector: (row) => row?.category?.name,
      sortable: true,
      width: "280px",
    },
    {
      name: "Name",
      selector: (row) => row.name,
      sortable: true,
      width: "300px",
    },
    {
      name: "Actions",
      cell: (row) => (
        <div className="flex gap-2">
          <button className="btn btn-lg" onClick={(e) => editProduct(e, row)}>
            <i className="icon-edit-3"></i>
          </button>
          <button
            className="btn btn-lg"
            onClick={(e) => deleteProduct(e, row.id)}
          >
            <i className="icon-trash-2"></i>
          </button>
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];

  return (
    <>
      <div className="main-content-inner">
        <div className="main-content-wrap">
          <div className="flex items-center flex-wrap justify-between gap20 mb-27">
            <h3>Product Categories List</h3>
            <ul className="breadcrumbs flex items-center flex-wrap justify-start gap10">
              <li>
                <Link to="/dashboard">
                  <div className="text-tiny">Dashboard</div>
                </Link>
              </li>
              <li>
                <i className="icon-chevron-right"></i>
              </li>
              <li>
                <div className="text-tiny">Product Categories List</div>
              </li>
            </ul>
          </div>
          <div className="wg-box">
            <div className="flex justify-end">
              <Link
                className="tf-button style-1 w208"
                onClick={(e) => addProduct(e)}
                style={{
                  textDecoration: "none",
                }}
              >
                <i className="icon-plus"></i>Add new
              </Link>
            </div>

            {error && <p className="text-danger">{error}</p>}

            <div className="datatable-container col-md-9">
              <div className="datatable-header">
                <input
                  type="text"
                  placeholder="Search product..."
                  className="datatable-search"
                  value={filterText}
                  onChange={(e) => setFilterText(e.target.value)}
                />
                {filterText && (
                  <button
                    className="datatable-clear"
                    onClick={() => setFilterText("")}
                  >
                    ✕
                  </button>
                )}
              </div>
              <DataTable
                columns={columns}
                data={filteredItems}
                progressPending={loading}
                pagination
                highlightOnHover
                striped
                responsive
                defaultSortField="name"
              />
              <div className="divider"></div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Product;
